import React from 'react';
import TargetApplicationTemplate from 'components/organismos/organization/TargetApplication';

const TargetApplicationForm: React.FC = (
) => {
    return (
      <React.Fragment>
        <TargetApplicationTemplate />
      </React.Fragment>
    );
  };

export default TargetApplicationForm;
